module.exports = "<progress-bar class=\"api-progress-bar no-print\" :value=\"percentage\" v-show=\"percentage\"></progress-bar>\n"